import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout as apiLogout } from "../api/client";

const NAV = [
  { to: "/",                label: "Dashboard",        icon: "🏠" },
  { to: "/gdpb",            label: "GDPB",             icon: "🚀" },
  { to: "/gvc",             label: "GVC — Auditoria",  icon: "🔍" },
  { to: "/gvc/resultados",  label: "GVC — Resultados", icon: "📊", indent: true },
  { to: "/shared",          label: "Shared",           icon: "🔗" },
  { to: "/modulos",         label: "Módulos",          icon: "⚙️"  },
  { to: "/gav",             label: "Avaliações Amazon", icon: "⭐" },
  { to: "/mercado-ads",     label: "Mercado Ads",      icon: "📣" },
  { to: "/configuracoes",   label: "Configurações",    icon: "🛠️"  },
];

export default function Layout({ children }) {
  const location = useLocation();
  const navigate  = useNavigate();

  const logout = async () => {
    try { await apiLogout(); } finally { navigate("/login"); }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="w-56 bg-blue-900 text-white flex flex-col shrink-0">
        <div className="px-5 py-6 border-b border-blue-800">
          <h1 className="text-lg font-bold tracking-wide">GEG</h1>
          <p className="text-blue-300 text-xs mt-0.5">Gestão Estância Geek</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(({ to, label, icon, indent }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                  indent ? "ml-4 text-xs" : ""
                } ${
                  active
                    ? "bg-blue-700 text-white font-semibold"
                    : "text-blue-200 hover:bg-blue-800 hover:text-white"
                }`}
              >
                <span>{icon}</span>
                {label}
              </Link>
            );
          })}
        </nav>

        <div className="px-3 py-4 border-t border-blue-800">
          <button
            type="button"
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2 text-sm text-blue-300 hover:text-white hover:bg-blue-800 rounded-lg transition-colors"
          >
            <span>🚪</span> Sair
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <div className="max-w-full px-6 py-8">{children}</div>
      </main>
    </div>
  );
}
